module.exports = __webpack_public_path__ + "static/media/culti.3eb6ae69.png";